import script from "./goRinSyo0072.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0072.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0072.vue?vue&type=style&index=0&id=2bffcdc1&lang=scss"

const __exports__ = script;

export default __exports__